import React, { useState } from 'react';
import { GOLD, DARK } from '../constants/theme';
import { IMGS } from '../constants/images';
import SecLabel from './ui/SecLabel';

const testi = [
  { name:'Vinay Prasad', event:'Wedding Reception',    text:'Gowjee Events was a true saviour during our wedding planning. From decor and lighting to food, the team executed everything beautifully and exactly as we envisioned. A big thank you to the entire team for making our reception spectacular. Highly recommended!', stars:5, img:IMGS.testimonial[0] }];

const Testimonials: React.FC = () => {
  const [curr, setCurr] = useState(0);
  const t = testi[curr];
  return (
    <section style={{ background:DARK, padding:'90px 8vw', position:'relative', overflow:'hidden' }}>
      <div style={{ position:'absolute', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:'55vw', height:'55vw', maxWidth:520, maxHeight:520, border:'1px solid rgba(196,152,50,0.05)', borderRadius:'50%', pointerEvents:'none' }}/>
      <SecLabel text="CLIENT STORIES"/>
      <h2 style={{ fontFamily:'Cormorant Garamond', fontSize:'clamp(28px,3.6vw,48px)', fontWeight:300, color:'#fff', textAlign:'center', marginTop:6 }}>
        What Our Guests <em style={{ color:GOLD }}>Say</em>
      </h2>
      <div style={{ maxWidth:660, margin:'52px auto 0', textAlign:'center', position:'relative' }}>
        <div style={{ fontSize:64, color:GOLD, lineHeight:0.8, fontFamily:'Georgia', opacity:0.3 }}>"</div>
        <p style={{ fontFamily:'Cormorant Garamond', fontSize:19, fontStyle:'italic', color:'rgba(255,255,255,0.8)', lineHeight:1.85, marginTop:16 }}>{t.text}</p>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:14, marginTop:28 }}>
          <img src={t.img} alt={t.name} style={{ width:54, height:54, borderRadius:'50%', objectFit:'cover', border:`2px solid ${GOLD}` }}/>
          <div style={{ textAlign:'left' }}>
            <div style={{ color:GOLD, fontSize:12 }}>{'★'.repeat(t.stars)}</div>
            <div style={{ fontFamily:'Montserrat', fontWeight:600, color:'#fff', fontSize:11, letterSpacing:1.5, textTransform:'uppercase', marginTop:2 }}>{t.name}</div>
            <div style={{ fontFamily:'Montserrat', fontSize:9, color:GOLD, letterSpacing:1.5, marginTop:2 }}>{t.event}</div>
          </div>
        </div>
        <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:28 }}>
          {testi.map((_,i) => (
            <button key={i} onClick={() => setCurr(i)} style={{ width:i===curr?26:7, height:7, borderRadius:4, background:i===curr?GOLD:'rgba(196,152,50,0.28)', border:'none', cursor:'pointer', transition:'all 0.4s' }}/>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;